export default {
    methods: {
        enable_ad_bar() {
            return this.$store.getters.ad_mode != null;
        }
    }
}